if (!customElements.get('recommended-products')) {
  class RecommendedProducts extends HTMLElement {
    constructor() {
      super();
      this.tileType = this.dataset.tileType || 'PDP';
      this.variantId = this.dataset.variantId;
      this.recNumber = this.dataset.recNumber || 10;
      this.indexPrefix = this.dataset.prefix;
      this.currentIndex = `${this.indexPrefix}products${getSuffix()}`;

    }

    connectedCallback() {
      if (!this.variantId) {
        this.closest('.product-recommended-products')?.classList.add('hidden');
        return;
      }
      
      poll(() => {
        return window.algoliasearch;
      }, 10000, 150).then(() => {
        this.init();
      }) 
    }
    
    init() {
      if (!this.variantId) return;
      const client = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale  

      client.getRelatedProducts([
        {
          indexName: this.currentIndex,
          objectID: this.variantId,
        },
      ])
      .then(({ results }) => {
        this.renderResults(results[0]?.hits);
      })
      .catch(err => {
        console.error(err);
        this.closest('.shopify-section.pdp-recommended-products')?.classList.add('hidden');
      });
    }
    
    renderResults(products) {
      const bannedtags = ['base-product', 'hide-product', 'base_product', 'hide_product'];
      const filteredProducts = products.filter((product) => product.inventory_available !== false && !bannedtags.some(i => product.tags.includes(i)));
      if (filteredProducts.length < 1 || !filteredProducts) {
        this.closest('.shopify-section').classList.add('hidden');
        return;
      }
      if (this.tileType == 'PDP') {
        this.innerHTML = `
          <div class="relative z-[1]">
            <swiper-carousel 
              data-space-between="8"
              data-slides-per-view="4"
              data-slides-per-view-mobile="2.5"
              class="hidden md:flex flex-col w-full pb-8"
              data-pagination="true"
              data-external-nav-buttons="recommended-pdp-slider"
            >
              <button data-prev="recommended-pdp-slider" class="button-slider disabled:hidden absolute left-0 top-1/2 z-10 bg-secondaryLight border-primaryLight transform -translate-x-1/2 shadow-lg" data-prev>
                <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                </svg>
              </button>
              <button data-next="recommended-pdp-slider" class="button-slider disabled:hidden absolute right-0 top-1/2 z-10 bg-secondaryLight border-primaryLight shadow-lg transform translate-x-1/2" data-next>
                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
                </svg>
              </button>
              <div class="swiper-wrapper">
                ${filteredProducts.slice(0, this.recNumber ).map((product) => `
                  <div class="swiper-slide [&_product-tile]:h-full !h-auto">
                    <intersection-loader 
                      data-url="${Shopify.routes.root}products/${product.handle}"
                      data-section-id="recently-viewed-product-tile"
                      data-load-immediately="true"
                    ></intersection-loader>                    
                  </div>
                `).join('')}
              </div>
            </swiper-carousel>
            <div class="grid grid-cols-2 gap-4 md:hidden">
              ${filteredProducts.slice(0, this.recNumber ).map((product) => `
                <div class="swiper-slide [&_product-tile]:h-full !h-auto">
                  <intersection-loader 
                    data-url="${Shopify.routes.root}products/${product.handle}"
                    data-section-id="recently-viewed-product-tile"
                    data-load-immediately="true"
                  ></intersection-loader>                    
                </div>
              `).join('')}
            </div>
          </div>
        `;
      } else {
        this.innerHTML = `
          <ul class="flex flex-col gap-3.5">
            ${filteredProducts.slice(0, this.recNumber ).map((product) => `
              <li>  
                <intersection-loader 
                  data-load-immediately="true"
                  data-url="${Shopify.routes.root}products/${product.handle}"
                  data-section-id="rec-tile"
                  class="aspect-auto h-[60px] w-full loading flex items-center justify-center relative"
                >
                <div class="loader">
                  <span class="block w-8 h-8">
                    <svg class="animate-spin -ml-1 mr-3 h-full w-full text-primaryBrand" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                      <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                  </span>
                </div>
                </intersection-loader>    
              </li>
            `).join('')}
          </ul>
        `;
      }
    }
  }

  customElements.define('recommended-products', RecommendedProducts);
}